import { action, extendObservable } from 'mobx';
// import { toJS } from 'mobx';
import { SORT_LAST_MODIFIED, SORT_AZ, SORT_ZA } from '../helpers/constants';
import { naturalSorter } from '../helpers/utils';
import _ from 'lodash';
import { getUnix } from '../helpers/utils';

import { saveNumberByKeyStringInLocalStorageArray, isKeyExists } from '../helpers/localStorage';
import store from './store';
import * as local from '../helpers/localStorage';

export default class GroupsStore {
    constructor(factory) {
        this.factory = factory;
        this.groupsUpdateDelegate = null;

        extendObservable(this, {
            selectedId: null,
            selectedGovCatId: null,
            loadingGov: false,
            selectedDocuments: [],
            collapsed: false,
            hasNewItems: false,
            isDownloading: 0,
            sorted: SORT_LAST_MODIFIED,

            setData: action(json => {
                this.data = json;
            }),

            setGroupHasNewItems: action((group, value) => {
                group.hasNewItems = value;
            }),

            get selectedGroup() {
                if (this.selectedId === null) {
                    return null;
                } else {
                    // make sure that groups are not in the process of being refreshed
                    if (this.loadingGov) {
                    let selectedCompanyIndex = this.factory.companies.selectedIndex;
                    let groups = store.companies.groups[selectedCompanyIndex];
                    if (groups !== undefined) {
                        let group = _.find(groups.Groups, g => {
                            return g.GroupId === this.selectedId;
                        });

                        if (group !== undefined) {
                            return group;
                        }
                    }
                }
                }
                return null;
            },

            getGroup(instanceId, groupId) {
                var index = store.companies.getCompanyIndexById(instanceId);
                let groups = store.companies.groups[index];
                if (groups !== undefined) {
                    let group = _.find(groups.Groups, g => {
                        return g.GroupId === groupId;
                    });

                    return group;
                }

                return null;
            },

            setGovLoading: action('setGovLoading', isLoading => {
                this.loadingGov = isLoading;
            }),

            selectedGroupGovernanceCategories: () => {
                if (this.selectedId === null) {
                    return null;
                } else {
                    if (this.selectedGroup === null || this.selectedGroup === undefined) {
                        return null;
                    }

                    return this.selectedGroup.governanceCategories;
                }
            },

            get getTreeData() {
                return this.selectedGroup.governanceCategories;
            },

            get isGovernanceExists() {
                return this.selectedGroupGovernanceCategories();
            },

            get selectedGovernanceCategory() {
                const group = this.selectedGroup;

                return _.find(group.governanceCategories, g => {
                    return g.GovCatId === this.selectedGovCatId;
                });
            },

            fixCategoriesHasUnreadDocumentsValue: group => {
                group.governanceCategories.forEach(function(category) {
                    if (!category.HasUnreadDocuments && category.children) {
                        factory.groups.isCategoryNew(category.GovCatId);
                    }
                });
            },

            governanceCategoryHasUnreadDocuments(Id) {
                const group = this.selectedGroup;
                const category = _.find(group.governanceCategories, g => {
                    return g.GovCatId === Id;
                });
                return category.HasUnreadDocuments;
            },

            decreaseSelectedGroupNumberOfUnreadDocuments: action(() => {              
                this.selectedGroup.NumberOfUnreadDocuments--;
            }),

            isCategoryNew: action(Id => {
                const company = this.factory.companies.getCompanyByIndex();
                const group = this.selectedGroup;
                let category = _.find(group.governanceCategories, c => {
                    return c.GovCatId === Id;
                });
                let allCategories = [];
                allCategories.push(category);
                let totalNumberOfDocuments = category.NumberOfDocuments;
                let numberOfReadDocuments = 0;

                let children = _.filter(group.governanceCategories, g => {
                    return g.ParentId === category.GovCatId;
                });
                if (children.length > 0) {
                    children.forEach(function(child) {
                        if (child.NumberOfDocuments > 0) {
                            totalNumberOfDocuments += child.NumberOfDocuments;
                        }
                        allCategories.push(child);

                        let secChildren = _.filter(group.governanceCategories, g => {
                            return g.ParentId === child.GovCatId;
                        });
                        if (secChildren.length > 0) {
                            secChildren.forEach(function(secChild) {
                                if (secChild.NumberOfDocuments > 0) {
                                    totalNumberOfDocuments += secChild.NumberOfDocuments;
                                }

                                allCategories.push(secChild);
                            });
                        }
                    });
                }

                allCategories.forEach(function(cat) {
                    for (let i = 0; i <= cat.GovernanceDocs.length - 1; i++) {
                        const docId = cat.GovernanceDocs[i].GovDocId;
                        if (
                            isKeyExists(
                                local.LS_GOVERNANCE +
                                    company.InstanceId.toString() +
                                    group.GroupId.toString() +
                                    store.user.profile[0].UserId,
                                docId,
                            )
                        ) {
                            numberOfReadDocuments++;
                        }
                    }
                });

                category.HasUnreadDocuments = totalNumberOfDocuments > numberOfReadDocuments;
            }),

            checkCategoriesForUnreadDocuments: action(Id => {
                const company = this.factory.companies.getCompanyByIndex();
                const group = this.selectedGroup;
                let category = _.find(group.governanceCategories, c => {
                    return c.GovCatId === Id;
                });
                if (this.categoryHasUnreadDocuments(company.InstanceId, group.GroupId, category)) {
                    category.HasUnreadDocuments = true;
                }
            }),

            categoryHasUnreadDocuments: action((companyId, groupId, category) => {
                return true;
            }),

            getGroupsByCompanyIndex(index) {
                let groups = this.factory.companies.groups[index];
                return groups;
            },

            // from Stanley
            get anyGroupSelected() {
                return this.selectedId !== null;
            },

            togglePanel: action(() => {
                this.collapsed = !this.collapsed;
            }),

            initilizeSelectedDocuments: action(() => {
                this.selectedDocuments = [];
            }),
            getNameByIndex(index) {
                const group = this.selectedGroup;

                if (group != null) {
                    return group.GroupName;
                }

                return '';
            },
            toggleSelected: action((GroupId, groupsIndex) => {
                //
                if (this.selectedId === null) {
                    // DO NOT CHANGE THIS
                    this.selectedId = GroupId; // select
                    if (this.factory.companies.selectedIndex === null) {
                        // DO NOT CHANGE THIS
                        this.factory.companies.toggleSelected(groupsIndex);
                    }
                } else {
                    if (this.selectedId === GroupId) {
                        this.selectedId = null; // deselect
                    } else {
                        this.selectedId = GroupId; // select
                        // this.factory.companies.toggleSelected(groupsIndex)
                    }
                }

                //toggle the meeting tab as needed
                this.factory.meetings.filterMeetingsByHierarchy();
                this.factory.meetings.checkForMeetings();
                this.factory.votes.refreshShouldDisplayVoteTab();
                this.factory.tasks.refreshShouldDisplayTaskTab();

                this.factory.tasks.clearAllFilters();
                this.factory.tasks.currentFilterSelection = 0;
                this.factory.tasks.currentColumnOrder = 'asc';
            }),

            get allGroups() {
                let groups = [];
                if (this.factory.companies.groups && this.factory.companies.groups.length > 0) {
                    this.factory.companies.groups.forEach((company, i) => {
                        if (company) {
                            company.Groups.forEach(group => {
                                groups.push(group);
                            });
                        }
                    });
                    // If we have company selected
                    if (this.factory.companies.selectedIndex !== null) {
                        //
                        //groups = this.factory.companies.groups[this.factory.companies.selectedIndex].Groups || [];
                        groups = _.get(
                            this.factory.companies,
                            'groups[' + this.factory.companies.selectedIndex + '].Groups',
                            [],
                        );
                    }
                }

                // sorting here
                if (this.sorted) {
                    switch (this.sorted) {
                        case SORT_ZA:
                            groups = groups.sort((a, b) => naturalSorter(b.GroupName, a.GroupName));
                            break;
                        case SORT_AZ:
                            groups = groups.sort((a, b) => naturalSorter(a.GroupName, b.GroupName));
                            break;
                        default:
                            groups = groups.sort((a, b) => b.lastActivity - a.lastActivity);
                    }
                }
                return groups;
            },

            sort: action(type => {
                if (type === this.sorted) return;
                this.sorted = type;
            }),

            checkSelectedGovCatId: action(oldSelectedId => {
                if (this.selectedId !== oldSelectedId) {
                    this.selectedGovCatId = null;
                }
            }),

            changeSelectedGovCatId: action(Id => {
                this.selectedGovCatId = Id;
                this.setSelectedDocuments();
            }),

            setIsDownloading: action(inputText => {
                this.isDownloading = inputText;
            }),

            checkIfParentHasUnreadDocuments: action(() => {
                let group = this.selectedGroup;
                if (group !== null) {
                    group.governanceCategories.forEach(function(category) {
                        if (!category.HasUnreadDocuments && category.children) {
                            factory.groups.isCategoryNew(category.GovCatId);
                        }
                    });
                }
            }),

            setSelectedDocuments: action(() => {
                this.initilizeSelectedDocuments();
                if (this.selectedGovCatId !== null) {
                    const lst = [];
                    const categories = this.selectedGroupGovernanceCategories();
                    let category = _.find(categories, c => {
                        return c.GovCatId === this.selectedGovCatId;
                    });
                    const company = this.factory.companies.getCompanyByIndex();
                    const group = this.selectedGroup;

                    if (category !== undefined && category.NumberOfDocuments > 0) {
                        category.GovernanceDocs.forEach(function(document) {
                            document.IsRead = isKeyExists(
                                local.LS_GOVERNANCE +
                                    company.InstanceId.toString() +
                                    group.GroupId.toString() +
                                    store.user.profile[0].UserId,
                                document.GovDocId,
                            );
                            lst.push({
                                Id: document.GovDocId,
                                DocName: document.DocName,
                                IsRead: document.IsRead, // MUST CHECK LOCAL STORAGE
                                DocModified: getUnix(document.DocModified),
                                DocType: document.DocType,
                                DocExtension: document.DocExtension,
                                DocPermissions: document.DocPermissions,
                                IsDownloading: false,
                                IsDownloaded: false,
                                DocUrl: document.DocUrl,
                                DocAnnotations: document.DocAnnotations,
                                Converted: document.Converted
                            });
                        });

                        this.selectedDocuments = lst;
                    }
                }
            }),

            makeDocumentRead: action(Id => {
                if (this.selectedDocuments.length > 0) {
                    let document = _.find(this.selectedDocuments, d => {
                        return d.Id === Id;
                    });
                    if (document && !document.IsRead) {
                        document.IsRead = true;

                        // get the selected group and change the
                        this.decreaseSelectedGroupNumberOfUnreadDocuments();
                        // enter doc Id in the local storage
                        const company = this.factory.companies.getCompanyByIndex();
                        const group = this.selectedGroup;
                        saveNumberByKeyStringInLocalStorageArray(
                            local.LS_GOVERNANCE +
                                company.InstanceId.toString() +
                                group.GroupId.toString() +
                                store.user.profile[0].UserId,
                            Id,
                        );
                        let category = this.selectedGovernanceCategory;
                        this.isCategoryNew(category.GovCatId);
                        if (category.ParentId !== 0) {
                            let parentCategory = _.find(group.governanceCategories, c => {
                                return c.GovCatId === category.ParentId;
                            });
                            this.isCategoryNew(parentCategory.GovCatId);

                            if (parentCategory.ParentId !== 0) {
                                let grandCategory = _.find(group.governanceCategories, c => {
                                    return c.GovCatId === parentCategory.ParentId;
                                });
                                this.isCategoryNew(grandCategory.GovCatId);
                            }
                        }

                        store.groups.resetVisualIndicatorsToSelectedGroup();
                    }
                }
            }),
        });
    }

    getNodes = parent => {
        const parentId = parent ? parent.Id : 0;
        const lst = [];
        let allGroupCategories = this.selectedGroupGovernanceCategories();
        let sameLevelCategories = _.filter(allGroupCategories, g => {
            return g.ParentId === parentId;
        });

        this.checkIfParentHasUnreadDocuments();
        if (sameLevelCategories.length > 0) {
            sameLevelCategories.forEach(function(category) {
                category.Id = category.GovCatId;
                lst.push(category);
            });
        }

        return lst;
    };

    setVisualIndicatorsToGroupsAndCompanies = () => {
        if (store.companies.data.Companies != null) {
            store.companies.data.Companies.forEach((company, index) => {
                let groups = store.companies.groups[index];
                const instanceId = company.InstanceId;
                let anyGroupNew = false
                if (groups != null) {
                    groups.Groups.forEach(group => {
                        let hasNew = groupHasNew(group)
                        store.groups.setGroupHasNewItems(group, hasNew)

                        if( hasNew) {
                            anyGroupNew = true
                        }

                        function groupHasNew(group) {

                            if (local.countMeetingBadgesForGroup(group) > 0) {
                                return true
                            }

                            if (store.votes && store.votes.getNumberOfNewVotesPerGroup && store.votes.getNumberOfNewVotesPerGroup(instanceId, group.GroupId) > 0) {
                                return true
                            }

                            if (store.task && store.task.numberOfAllNewTasks && store.task.numberOfAllNewTasks() > 0) {
                                return true
                            }

                            if (group.governanceCategories != null && group.governanceCategories.length > 0) {
                                for (let cat of group.governanceCategories) {
                                    if (cat.HasUnreadDocuments) {
                                        return true
                                    }
                                }
                            }

                            return false
                        }
                    });
                }
                store.companies.setCompanyHasNewItems(company, anyGroupNew)
            });
        }
    };



    resetVisualIndicatorsToSelectedGroup = () => {
        if (store.groups.selectedGroup !== null) {
            if (store.groups.selectedGroup.hasNewItems) {
                var group = store.groups.selectedGroup;
                var company = store.companies.selectedCompany;
                var numberOfMeetingBadges = local.countMeetingBadgesForGroup(group);

                var numberOfVoteBadges = 0;

                if (store.vote !== undefined) {
                    numberOfVoteBadges = store.vote.getNumberOfNewVotesPerGroup(
                        company.InstanceId,
                        group.GroupId,
                    );
                }

                var numberOfTaskBadges = 0;

                if(store.tasks !== undefined && store.tasks.data !== undefined) {
                    numberOfTaskBadges = store.tasks.numberOfAllNewTasks();
                }

                if (numberOfMeetingBadges === 0 && numberOfVoteBadges === 0 && numberOfTaskBadges === 0) {
                    store.groups.setGroupHasNewItems(group, false);
                    store.companies.setCompanyHasNewItems(company, false);
                    if (
                        group.governanceCategories !== undefined &&
                        group.governanceCategories !== null &&
                        group.governanceCategories.length > 0
                    ) {
                        for (var i = 0; i < group.governanceCategories.length; i++) {
                            if (group.governanceCategories[i].HasUnreadDocuments) {
                                store.groups.setGroupHasNewItems(group, true);
                                store.companies.setCompanyHasNewItems(company, true);
                                break;
                            }
                        }
                    }

                    if (!group.hasNewItems) {
                        var index = store.companies.getCompanyIndexById(company.InstanceId);
                        let groups = store.companies.groups[index];

                        if (
                            groups !== undefined &&
                            groups !== null &&
                            groups.Groups !== undefined &&
                            groups.Groups.length > 0
                        ) {
                            for (var x = 0; x < groups.Groups.length; x++) {
                                if (groups.Groups[x].hasNewItems) {
                                    store.companies.setCompanyHasNewItems(company, true);
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        }
    };

    resetVisualIndicatorsForGroup = (instanceId, groupId) => {
        var company = store.companies.getCompanyById(instanceId);
        var group = store.groups.getGroup(instanceId, groupId);

        var numberOfMeetingBadges = local.countMeetingBadgesForGroup(group);

        var numberOfVoteBadges = 0;

        if (store.vote !== undefined) {
            numberOfVoteBadges = store.vote.getNumberOfNewVotesPerGroup(instanceId, groupId);
        }

        var numberOfTaskBadges = 0;

        if(store.tasks !== undefined && store.tasks.data !== undefined) {
            numberOfTaskBadges = store.tasks.numberOfAllNewTasks();
        }

        if (numberOfMeetingBadges === 0 && numberOfVoteBadges === 0 && numberOfTaskBadges === 0) {
            store.groups.setGroupHasNewItems(group, false);
            store.companies.setCompanyHasNewItems(company, false);
            if (
                group.governanceCategories !== undefined &&
                group.governanceCategories !== null &&
                group.governanceCategories.length > 0
            ) {
                for (var i = 0; i < group.governanceCategories.length; i++) {
                    if (group.governanceCategories[i].HasUnreadDocuments) {
                        store.groups.setGroupHasNewItems(group, true);
                        store.companies.setCompanyHasNewItems(company, true);
                        break;
                    }
                }
            }

            if (!group.hasNewItems) {
                var index = store.companies.getCompanyIndexById(company.InstanceId);
                let groups = store.companies.groups[index];

                if (
                    groups !== undefined &&
                    groups !== null &&
                    groups.Groups !== undefined &&
                    groups.Groups.length > 0
                ) {
                    for (var x = 0; x < groups.Groups.length; x++) {
                        if (groups.Groups[x].hasNewItems) {
                            store.companies.setCompanyHasNewItems(company, true);
                            break;
                        }
                    }
                }
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/stores/GroupsStore.js